import React from 'react';
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import { Link } from 'react-router-dom';
import { Button, Container, MainHeading } from '../../globalStyles';
import { HeroSection, ClientSection } from './HeroStyles';
import HeroCarousel from './HeroCarousel';
import Clientes from '../Carousel/Clientes';

const languages = [
	{
	  code: 'es',
	  name: 'Español',
	  country_code: 'es',
	},
	{
	  code: 'en',
	  name: 'English',
	  country_code: 'gb',
	},
	{
	  code: 'chn',
	  name: '中國人',
	  country_code: 'chn',
	},
  ]

export default function Hero() {
	const { t } = useTranslation()
  return (
    <>
      <HeroSection>
        <HeroCarousel />
      </HeroSection>
      <ClientSection>
        <Clientes/>
      </ClientSection>
    </>
  )
}
